import React, { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

const RedirectIfAuthenticated = ({ children }) => {
  const navigate = useNavigate();
  const { id } = useParams();
 const [searchParams] = useSearchParams();
  const trackCode = searchParams.get("track");
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.contestId === id) {

      const navigatePath = trackCode 
      ? `/dashboard/${id}?track=${trackCode}`
      : `/dashboard/${id}`;
      
    navigate(navigatePath);
      // navigate(`/dashboard/${id}`);
    }
  }, [navigate, id]);

  return children;
};

export default RedirectIfAuthenticated;
